import { createSelector } from 'reselect';

const selectTenantWebsites = (state: any) => state.tenantWebsites;


export const selectTenantWebsitesCurrentItem = createSelector([selectTenantWebsites], (tenantWebsites) => tenantWebsites.current);

export const selectTenantWebsitesListItems = createSelector([selectTenantWebsites], (tenantWebsites) => tenantWebsites.list);

export const selectItemById = (itemId: any) =>
    createSelector(selectTenantWebsitesListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectTenantWebsitesQueryItems = createSelector([selectTenantWebsites], (tenantWebsites) => tenantWebsites.query);

export const selectTenantWebsitesCreatedItem = createSelector([selectTenantWebsites], (tenantWebsites) => tenantWebsites.create);

export const selectTenantWebsitesUpdatedItem = createSelector([selectTenantWebsites], (tenantWebsites) => tenantWebsites.update);

export const selectTenantWebsitesReadItem = createSelector([selectTenantWebsites], (tenantWebsites) => tenantWebsites.read);

export const selectTenantWebsitesDeletedItem = createSelector([selectTenantWebsites], (tenantWebsites) => tenantWebsites.delete);

export const selectTenantWebsitesSearchedItems = createSelector([selectTenantWebsites], (tenantWebsites) => tenantWebsites.search);

export const selectTenantWebsitesItemsCount = createSelector([selectTenantWebsites], (tenantWebsites) => tenantWebsites.count);

export const selectTenantWebsitesItemsFilter = createSelector([selectTenantWebsites], (tenantWebsites) => tenantWebsites.filter);